<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="970"
    style="border-radius: 8px"
  >
    <v-card class="create-user-dialog">
      <v-card-title class="primary px-4">
        <div class="d-flex align-center">
          <span
            class="white--text dialog-title"
            style="font-size: 16px !important; font-weight: 400"
            >Chỉnh sửa thông tin tổ</span
          >
        </div>
        <v-btn color="white" class="ml-auto" icon @click="cancelAction"
          ><v-icon size="20px">mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <div class="dialog-body-content">
        <div class="left-side scroll-y-mod_big">
          <div class="input-block py-2">
            <label class="input-form-label black--text pb-2"> Tên tổ </label>
            <input
              v-model="groupName"
              type="text"
              class="input input-form-border neutral_color_sub3 bg-white mb-2"
              :class="errorObj.groupName ? 'error-border' : ''"
              placeholder="Nhập tên tổ"
              readonly
            />
            <p
              v-if="errorObj.groupName"
              class="semantic_error--text error-msg-small mb-0"
            >
              {{ errorObj.groupName }}
            </p>
            <span
              class="small-charactor-count neutral_color_sub3--text"
              :class="
                groupName.length === limitGroupNameLength
                  ? 'reach-max semantic_error--text'
                  : ''
              "
            >
              {{ groupName.length }}/{{ limitGroupNameLength }}
            </span>
          </div>
          <div class="d-flex align-center justify-space-between">
            <p class="mb-0 mr-2 neutral--text" style="white-space: nowrap">
              Tổ trưởng:
            </p>
            <v-btn
              color="primary"
              text
              height="48px"
              class="primary_light primary_light-opacity btn-add-group low-letter-spacing font-weight-bold"
              style="border-radius: 8px"
              @click="onAddLeader"
            >
              <v-icon color="primary" class="mr-2">mdi-plus</v-icon>
              Chọn tổ trưởng
            </v-btn>
          </div>
          <v-row v-if="leaderSelectedComputed" class="list-user mt-3 m-0">
            <v-list-item class="p-0 list-contact__wr col-12">
              <UserCardBin
                :user="leaderSelectedComputed"
                :userClick="clearLeader"
              />
            </v-list-item>
          </v-row>
          <div class="d-flex align-center justify-space-between mt-3">
            <p class="mb-0 mr-2 neutral--text" style="white-space: nowrap">
              Danh sách thành viên
              {{ listUserIds.length ? `(${listUserIds.length})` : `` }}
            </p>
            <v-btn
              color="primary"
              text
              height="48px"
              class="primary_light primary_light-opacity btn-add-group low-letter-spacing font-weight-bold"
              style="border-radius: 8px"
              @click="onAddUser"
            >
              <v-icon color="primary" class="mr-2">mdi-plus</v-icon>
              {{ sysLanguage.button.addNewUser }}
            </v-btn>
          </div>
          <p
            v-if="errorObj.listUsers"
            class="semantic_error--text error-msg-small mb-0 text-left mt-1"
          >
            {{ errorObj.listUsers }}
          </p>
          <v-row class="list-user mt-3 m-0">
            <v-list-item
              v-for="user in listUserSelectedComputed"
              :key="user.id"
              class="p-0 list-contact__wr col-6"
            >
              <UserCardBin :user="user" :userClick="toggleUser" />
            </v-list-item>
          </v-row>
        </div>
      </div>
      <!-- ACTIONS -->
      <div class="news_block_bg py-2 px-3 group-btn-add-user mt-1 d-flex">
        <v-btn
          :disabled="loadingBtn"
          :color="'neutral_color_sub4 neutral_color_sub2--text'"
          class="rounded-lg v-btn-confirm ml-auto mr-2"
          @click="cancelAction"
          depressed
        >
          {{ sysLanguage.button.cancel }}
        </v-btn>
        <v-btn
          :color="'primary'"
          :loading="loadingBtn"
          class="rounded-lg v-btn-confirm"
          :disabled="!ableToCreate"
          @click="onSubmit"
          depressed
        >
          {{ sysLanguage.button.update }}
        </v-btn>
      </div>
    </v-card>
    <DialogAddUser
      :isVisible="showAddUserDialog"
      :confirmAction="addUser"
      :cancelAction="closeAddUserDialog"
      :usersDefaultIds="listUserIds"
      :disabledIds="leaderId ? [leaderId] : []"
    />
    <DialogAddUser
      :isVisible="showAddLeaderDialog"
      :confirmAction="addLeader"
      :cancelAction="closeAddLeaderDialog"
      singleSelect
      :usersDefaultIds="leaderId ? [leaderId] : []"
    />
  </v-dialog>
</template>

<script>
import handleFiles from "@/mixins/handleFiles.js"
import DialogAddUser from "@/components/Dialog/DialogAddUser.vue"
import UserCardBin from "@/components/ContactSidebar/UserCardBin.vue"
import api from "@/services"
import { mapState } from "vuex"
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    cancelAction: {
      type: Function,
      default() {},
    },
    confirmAction: {
      type: Function,
      default() {},
    },
    detailData: {
      type: [Object, null],
      default() {},
    },
  },
  components: { DialogAddUser, UserCardBin },
  mixins: [handleFiles],
  data() {
    return {
      showAddUserDialog: false,
      showAddLeaderDialog: false,
      dialog: false,
      loadingBtn: false,
      submitClicked: false,
      groupName: "",
      limitGroupNameLength: 60,
      listUserIds: [],
      leaderId: null,
    }
  },
  computed: {
    ...mapState({
      listUsers: (state) => state.users.listUsers,
    }),
    listUserSelectedComputed() {
      return this.listUsers.filter((o) => this.listUserIds.includes(o.id))
    },
    leaderSelectedComputed() {
      return this.listUsers.find((o) => o.id === this.leaderId)
    },
    ableToCreate() {
      return this.groupName.trim() && this.leaderId
    },
    errorObjUnder() {
      const obj = {}
      if (!this.groupName || !String(this.groupName).trim()) {
        obj.groupName = "Không được để trống tên tổ"
      }
      if (!this.leaderId) {
        obj.leaderId = "Không được để trống tổ trưởng"
      }
      return obj
    },
    errorObj() {
      return this.submitClicked ? this.errorObjUnder : {}
    },
  },
  watch: {
    isVisible() {
      this.resetData()
      this.dialog = this.isVisible
      if (this.isVisible) {
        this.syncData()
      }
    },
    groupName() {
      if (this.groupName.length > this.limitGroupNameLength) {
        this.groupName = this.groupName.slice(0, this.limitGroupNameLength)
      }
    },
  },
  mounted() {},
  methods: {
    resetData() {
      this.showAddUserDialog = false
      this.loadingBtn = false
      this.submitClicked = false
      this.groupName = ""
      this.listUserIds = []
      this.leaderId = null
    },
    syncData() {
      if (this.detailData) {
        this.groupName = this.detailData.name
        this.listUserIds =
          this.detailData.leader && Array.isArray(this.detailData.members)
            ? this.detailData.members
                .filter((o) => o.id !== this.detailData.leader.id)
                .map((o) => o.id)
            : [...(this.detailData.members || []).map((o) => o.id)]
        this.leaderId = this.detailData.leader
          ? this.detailData.leader.id
          : null
      }
    },
    clearLeader() {
      this.leaderId = null
    },
    onAddLeader() {
      this.showAddLeaderDialog = true
    },
    onAddUser() {
      this.showAddUserDialog = true
    },
    closeAddUserDialog() {
      this.showAddUserDialog = false
    },
    closeAddLeaderDialog() {
      this.showAddLeaderDialog = false
    },
    addLeader(_user) {
      const selectedId = _user.pop()
      this.leaderId = selectedId

      this.listUserIds = this.listUserIds.filter((o) => o !== selectedId)
      this.closeAddLeaderDialog()
    },
    addUser(_users) {
      this.listUserIds = [..._users]
      this.closeAddUserDialog()
    },
    toggleUser(_user) {
      console.log(_user)
      if (this.listUserIds.includes(_user.id)) {
        this.listUserIds = this.listUserIds.filter((o) => o !== _user.id)
      } else {
        this.listUserIds.push(_user.id)
      }
    },
    // USER HANDLER
    async onSubmit() {
      this.submitClicked = true
      if (Object.keys(this.errorObjUnder).length) {
        return
      }
      const members = [
        {
          user_id: this.leaderId,
          is_team_leader: 1,
        },
        ...this.listUserIds.map((o) => ({ user_id: o })),
      ]

      const body = {
        name: this.groupName,
        members,
      }
      this.loadingBtn = true
      const res = await api.warehousePoterTeamManagement.update(
        this.detailData.id,
        body,
      )
      this.loadingBtn = false
      if (!res) {
        this.$store.commit(
          "toast/getError",
          this.sysLanguage.snackbar.updatePorterTeamFail,
        )
        return
      }
      try {
        if (res.status && res.status >= 400) {
          this.$store.commit("toast/getError", res.data.message)
          return
        }
        this.$store.commit(
          "toast/getSuccess",
          this.sysLanguage.snackbar.updatePorterTeamSuccess,
        )
        this.confirmAction()
      } catch (error) {
        this.$store.commit("toast/getError", `${error}`)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.create-user-dialog {
  .dialog-title {
    font-weight: 400;
    font-size: 16px !important;
    line-height: 28px;
  }
  .dialog-body-content {
    display: flex;
    padding: 0 24px;
    max-height: calc(90vh - 70px - 54px);
    min-height: calc(90vh - 70px - 54px);
    .left-side {
      width: 100%;
      padding: 20px 8px 40px;
      max-height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      .input-form-border {
        border-radius: 8px;
        border: 1px solid;
        height: 48px;
        padding: 12px 8px;
        font-weight: 400;
        font-size: 16px;
        &.v-texarea-normalize {
          height: auto;
        }
      }
      .input-block {
        display: flex;
        flex-flow: column;
        &.flex-input {
          flex-flow: row;
        }
        .input {
          &:focus {
            outline: none;
          }
        }
        .input-form-label {
          letter-spacing: 0.0015em;
          font-weight: 400;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.date-picker--mod {
  .mx-input-wrapper {
    min-width: 280px;
    .mx-input {
      height: 44px;
      border-radius: 8px;
    }
  }
}
</style>
